const distributorReports = {
  Report: 'Informe',
  Reports: 'Informes',
  'About this report': 'Acerca de este informe',
  Apply: 'Aplicar',
  Filters: 'Filtros',
  Deposit: 'Depósito',
  Qty: 'Cant.',
  Request: 'Solicitud',
  'Amount (USD)': 'Importe (USD)',
  'Ordering access': 'Permiso para pedir',
  Business: 'Negocio',
  'Bank & purchases': 'Saldo y compras',
  Tools: 'Herramientas',
  'View, filter and export your business records.':
    'Consulte, filtre y exporte sus registros comerciales.',
  'Orders & resale': 'Pedidos y reventa',
  'Unit ledger': 'Movimientos de unidades',
  'Cash ledger': 'Movimientos de dinero',
  'Help requests': 'Solicitudes de ayuda',
  'Library documents': 'Documentos de la biblioteca',
  'Current customers, ordering access and resale rates.':
    'Clientes actuales, permisos de pedido y tarifas de reventa.',
  'One row per order item. Saved prices are shown when available.':
    'Una fila por producto del pedido. Los precios guardados se muestran cuando están disponibles.',
  'Coverage request statuses for your customers. Patient details are excluded.':
    'Estados de las solicitudes de cobertura de sus clientes. Se excluyen los datos de pacientes.',
  'Order status, tracking and expected delivery for your shipments.':
    'Estado del pedido, seguimiento y entrega prevista de sus envíos.',
  'Historical product-unit purchases, including purchases not yet credited.':
    'Compras históricas de unidades, incluidas las que aún no se han acreditado.',
  'Historical additions and deductions. Net movement is not available stock.':
    'Adiciones y deducciones históricas. El movimiento neto no es el stock disponible.',
  'Deposits, order charges and reversals. Each balance is saved at that entry.':
    'Depósitos, cargos de pedidos y anulaciones. Cada saldo corresponde a ese movimiento.',
  'Request references and statuses. Read messages in Help Center.':
    'Referencias y estados de solicitudes. Lea los mensajes en el Centro de ayuda.',
  'Currently published files. Open original documents in Resources & Tools.':
    'Archivos publicados actualmente. Abra los originales en Recursos y herramientas.',
  'Name or address': 'Nombre o dirección',
  'Order, customer or product': 'Pedido, cliente o producto',
  'Order or customer': 'Pedido o cliente',
  'Order or tracking': 'Pedido o seguimiento',
  'Product or payment': 'Producto o pago',
  'Product or reference': 'Producto o referencia',
  'Title or file name': 'Título o archivo',
  'Request or customer': 'Solicitud o cliente',
  'Order, customer or tracking': 'Pedido, cliente o seguimiento',
  'Product family or payment': 'Familia de productos o pago',
  'Product family or reference': 'Familia de productos o referencia',
  'Order or entry type': 'Pedido o tipo de movimiento',
  'Title, category or file': 'Título, categoría o archivo',
  'Customer added': 'Cliente agregado',
  'Dates filter': 'Las fechas filtran',
  'Available saved amounts (USD)': 'Importes guardados disponibles (USD)',
  'Saved amount (USD)': 'Importe guardado (USD)',
  'Recorded subtotal (USD)': 'Subtotal registrado (USD)',
  'Amounts unavailable': 'Importes no disponibles',
  'Report pages': 'Páginas del informe',
  'Resale rate (USD/unit)': 'Tarifa de reventa (USD/unidad)',
  'Expected delivery': 'Entrega prevista',
  'Unit change': 'Cambio de unidades',
  'Balance after (USD)': 'Saldo posterior (USD)',
  'Payment method': 'Forma de pago',
  'Last activity': 'Última actividad',
  Added: 'Agregado',
  'Rate: {rate} / unit': 'Tarifa: {rate} / unidad',
  '{count} units': '{count} unidades',
  'All types': 'Todos los tipos',
  '{count} customer': '{count} cliente',
  '{count} customers': '{count} clientes',
  '{count} order line': '{count} línea de pedido',
  '{count} order lines': '{count} líneas de pedido',
  '{count} request': '{count} solicitud',
  '{count} requests': '{count} solicitudes',
  '{count} shipment': '{count} envío',
  '{count} shipments': '{count} envíos',
  '{count} purchase': '{count} compra',
  '{count} purchases': '{count} compras',
  '{count} entry': '{count} movimiento',
  '{count} entries': '{count} movimientos',
  '{count} document': '{count} documento',
  '{count} documents': '{count} documentos',
  'Support reference': 'Referencia de soporte',
  'Distributor Reports': 'Informes del distribuidor',
  'View and export your business records. A QuickBooks connection is not required.':
    'Consulte y exporte sus registros comerciales. No se requiere una conexión con QuickBooks.',
  'Report dataset': 'Tipo de informe',
  'Report filters': 'Filtros del informe',
  'Report results': 'Resultados del informe',
  'All entry kinds': 'Todos los tipos de movimiento',
  'All statuses': 'Todos los estados',
  'Showing the last applied filters.': 'Se muestran los últimos filtros aplicados.',
  'Selected amounts include all matching order statuses; they are not recognized revenue.':
    'Los importes seleccionados incluyen todos los estados de pedido coincidentes; no son ingresos reconocidos.',
  'Order lines & resale': 'Líneas de pedidos y reventa',
  'IVR status records': 'Registros de estado de IVR',
  'Shipments & tracking': 'Envíos y seguimiento',
  'Unit purchases': 'Compras de unidades',
  'Bank ledger': 'Libro de movimientos del banco',
  'Support request summaries': 'Resúmenes de solicitudes de soporte',
  'Published resources': 'Recursos publicados',
  'Search records': 'Buscar registros',
  'Dates use UTC. Both selected days are included; blank dates include all available history.':
    'Las fechas usan UTC. Se incluyen ambos días seleccionados; las fechas vacías incluyen todo el historial disponible.',
  'Apply your changes before exporting.': 'Aplique sus cambios antes de exportar.',
  'Loading report...': 'Cargando informe...',
  'Could not load this report. Please try again.':
    'No se pudo cargar este informe. Vuelva a intentarlo.',
  'Could not export this report. Please try again.':
    'No se pudo exportar este informe. Vuelva a intentarlo.',
  '{count} matching rows': '{count} filas coincidentes',
  'File format': 'Formato de archivo',
  'Export all matching rows': 'Exportar todas las filas coincidentes',
  'Export includes every matching row across all pages, using the applied filters. Counts are refreshed when the report is loaded.':
    'La exportación incluye todas las filas coincidentes de todas las páginas, usando los filtros aplicados. Los recuentos se actualizan al cargar el informe.',
  'No records match these filters.': 'Ningún registro coincide con estos filtros.',
  'No records are available for this report yet.':
    'Aún no hay registros disponibles para este informe.',
  'Report records': 'Registros del informe',
  'Included fields and history': 'Campos e historial incluidos',
  'Date field': 'Campo de fecha',
  'Export columns': 'Columnas exportadas',
  'Excluded fields': 'Campos excluidos',
  'Original resource documents remain in Resources & Tools. Reports do not include patient records, message bodies, credentials or internal payment evidence.':
    'Los documentos originales permanecen en Recursos y herramientas. Los informes no incluyen registros de pacientes, cuerpos de mensajes, credenciales ni evidencia interna de pagos.',
  'Matching records': 'Registros coincidentes',
  'Matching rows': 'Filas coincidentes',
  'Selected amount (USD)': 'Importe seleccionado (USD)',
  'Rows with unavailable amounts': 'Filas con importes no disponibles',
  'Saved units': 'Unidades guardadas',
  'Net unit movement': 'Movimiento neto de unidades',
  'Customer membership created': 'Creación de la vinculación del cliente',
  'Order submitted': 'Envío del pedido',
  'IVR submitted': 'Envío de la IVR',
  'Shipment created': 'Creación del envío',
  'Purchase created': 'Creación de la compra',
  'Ledger entry created': 'Creación del movimiento',
  'Support request created': 'Creación de la solicitud de soporte',
  'Resource published': 'Publicación del recurso',
  'Ordering enabled': 'Pedidos habilitados',
  'Ordering disabled': 'Pedidos deshabilitados',
  'Entry kind': 'Tipo de movimiento',
  'Waiting on requester': 'Esperando al solicitante',
  'Record ID': 'ID del registro',
  'Created (UTC)': 'Creación (UTC)',
  'Customer ID': 'ID del cliente',
  'Current resale rate (USD/unit)': 'Tarifa de reventa actual (USD/unidad)',
  'Credit limit (USD)': 'Límite de crédito (USD)',
  'Delivery street': 'Calle de entrega',
  'Delivery city': 'Ciudad de entrega',
  'Delivery state': 'Estado de entrega',
  'Delivery ZIP': 'Código postal de entrega',
  'Allowed product IDs (blank means no membership restriction)':
    'ID de productos permitidos (vacío significa sin restricción de vinculación)',
  'Order number': 'Número de pedido',
  'Line number': 'Número de línea',
  'Product ID': 'ID del producto',
  'Product (current name)': 'Producto (nombre actual)',
  'Accepted resale rate (USD/unit)': 'Tarifa de reventa aceptada (USD/unidad)',
  'Line amount (USD cents)': 'Importe de línea (centavos de USD)',
  'Line amount (USD)': 'Importe de línea (USD)',
  'Amount evidence': 'Evidencia del importe',
  'Saved accepted amount': 'Importe aceptado guardado',
  'Amount unavailable': 'Importe no disponible',
  'Request number': 'Número de solicitud',
  'Effective status': 'Estado efectivo',
  'Stored status': 'Estado guardado',
  'Updated (UTC)': 'Actualización (UTC)',
  'Order/shipment status': 'Estado del pedido/envío',
  'Stored shipment status': 'Estado guardado del envío',
  'Tracking number': 'Número de seguimiento',
  'Estimated delivery (UTC)': 'Entrega estimada (UTC)',
  'Purchase status': 'Estado de compra',
  'Payment attempt state': 'Estado del intento de pago',
  'Return review open': 'Revisión de devolución abierta',
  'Accepted wholesale rate (USD/unit)': 'Tarifa mayorista aceptada (USD/unidad)',
  'Purchased units': 'Unidades compradas',
  'Purchase amount (USD cents)': 'Importe de compra (centavos de USD)',
  'Purchase amount (USD)': 'Importe de compra (USD)',
  'Credited (UTC)': 'Acreditación (UTC)',
  'Closed (UTC)': 'Cierre (UTC)',
  'Units change': 'Cambio de unidades',
  'Order record ID': 'ID del registro de pedido',
  'Purchase record ID': 'ID del registro de compra',
  'Request status': 'Estado de la solicitud',
  'Last message (UTC)': 'Último mensaje (UTC)',
  'Resource ID': 'ID del recurso',
  'Published (UTC)': 'Publicación (UTC)',
  'Published title': 'Título publicado',
  'File bytes': 'Bytes del archivo',
  'Patient and clinical information': 'Información clínica y de pacientes',
  'Legacy patient-name/PO fields': 'Campos antiguos de nombre de paciente y orden de compra',
  'Support subjects, messages and attachments': 'Asuntos, mensajes y adjuntos de soporte',
  'Direct-business rates and clinic-owned addresses':
    'Tarifas del negocio directo y direcciones propias de las clínicas',
  'Payment evidence, provider identifiers and secrets':
    'Evidencia de pagos, identificadores de proveedores y secretos',
  'Private file keys, drafts and internal audit/retry fields':
    'Claves privadas de archivos, borradores y campos internos de auditoría y reintento',
  'Current active customer memberships and active practices only. Dates select membership creation; rates and names are current, not historical.':
    'Solo vinculaciones de clientes y consultorios activos. Las fechas seleccionan la creación de la vinculación; las tarifas y nombres son actuales, no históricos.',
  'One row per saved order line for currently authorized customers; all order statuses, excluding soft-deleted records. Saved accepted resale evidence only; missing or mismatched evidence is unavailable. Current prices never recalculate past sales. Totals include cancelled orders when selected and are not recognized revenue.':
    'Una fila por línea guardada de pedido de los clientes actualmente autorizados; todos los estados, salvo registros eliminados. Solo evidencia guardada de reventa aceptada; la evidencia ausente o incoherente no está disponible. Los precios actuales nunca recalculan ventas anteriores. Los totales incluyen pedidos cancelados seleccionados y no representan ingresos reconocidos.',
  'Status records for currently authorized customers, excluding soft-deleted requests. Historical rejected statuses before the current policy are shown as needs_review; stored status is retained separately.':
    'Registros de estado de clientes actualmente autorizados, salvo solicitudes eliminadas. Los rechazos históricos anteriores a la política actual se muestran como pendientes de revisión; el estado guardado se conserva por separado.',
  'Non-deleted distributor shipments linked to non-deleted orders for currently authorized customers. Shipment and order ownership must both match. Completed means the shipment or linked order is completed; otherwise status follows the order. Dates select shipment creation.':
    'Envíos del distribuidor vinculados a pedidos de clientes actualmente autorizados, sin registros eliminados. La propiedad del envío y del pedido debe coincidir. Completado significa que el envío o el pedido vinculado está completado; en otro caso se usa el estado del pedido. Las fechas seleccionan la creación del envío.',
  'All retained purchase records owned by the distributor, including closed and uncredited preparations, regardless of current customer or product access. Amount totals describe selected purchases, not settled cash or available stock.':
    'Todos los registros de compras conservados del distribuidor, incluidas preparaciones cerradas y no acreditadas, independientemente del acceso actual a clientes o productos. Los importes describen las compras seleccionadas, no efectivo liquidado ni existencias disponibles.',
  'All retained append-only unit ledger entries owned by the distributor, regardless of current customer or product access. Filtered net units are movement within this selection, not the opening or closing balance.':
    'Todos los movimientos de unidades conservados del distribuidor, independientemente del acceso actual a clientes o productos. Las unidades netas filtradas son movimientos de esta selección, no el saldo inicial ni final.',
  'Master: own organization-level requests plus requests of currently authorized customers. Admin: selected distributor organization-level requests plus current customers. Subjects, messages and attachments are intentionally omitted.':
    'Distribuidor: solicitudes propias de la organización y de los clientes actualmente autorizados. Administrador: solicitudes de la organización del distribuidor seleccionado y de sus clientes actuales. Se omiten los asuntos, mensajes y adjuntos.',
  'Currently published resources in this distributor library only, using the published snapshot, even if a newer draft exists. Dates select publication. Archived and draft-only resources are excluded; download original documents in Resources & Tools.':
    'Solo recursos actualmente publicados en la biblioteca del distribuidor, usando la versión publicada aunque exista un borrador más reciente. Las fechas seleccionan la publicación. Se excluyen archivos y borradores sin publicar; descargue los originales en Recursos y herramientas.',
};
export default distributorReports;
